import React, { useEffect } from "react";
import { useState } from "react";
import styles from "./filtersmodal.module.css";
import Button from "@atlaskit/button";

import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog";
import Spinner from "@atlaskit/spinner";
import { API } from "../../../utility/Api";
import { errorHandler } from "../../../helpers/helpers";
import { UseToast } from "../../context/ToastContext";
import TextArea from "@atlaskit/textarea";

const FiltersModal = ({
  showFilterModal,
  setShowFilterModal,
  whereAmI,
  jobToGoTo,
  jobType,
}) => {
  const [filtersMetadata, setFiltersMetadata] = useState();
  const { setMainMessage } = UseToast();

  const [isLoading, setIsLoading] = useState(false);
  const getRestoreFilterMetadata = async (token) => {
    setIsLoading(true);
    await API.get(`api/restore_filter_metadata?jobId=${jobToGoTo}`, {
      headers: {
        Authorization: `JWT ${token}`,
      },
    })
      .then(function (response) {
        setFiltersMetadata(response.data.restoreFiltersMetadata);

        setIsLoading(false);
      })
      .catch(function (error) {
        const data = errorHandler(error);
        setMainMessage({ appearance: "error", text: data.message });
        setIsLoading(false);
      });
  };

  useEffect(() => {
    // eslint-disable-next-line no-undef
    AP.context.getToken(function (token) {
      if (
        whereAmI === "restore" &&
        (jobType === "Quick" || jobType === "Issues")
      ) {
        getRestoreFilterMetadata(token);
      } else {
        // backup filters coming soon
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <ModalTransition>
      {showFilterModal && (
        <Modal onClose={() => setShowFilterModal(false)}>
          <ModalHeader>
            <ModalTitle>
              Restore Filters Metadata
              {isLoading && <Spinner size="small" />}
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div className={styles.textcontainer}>
              <TextArea
                resize="none"
                minimumRows="30"
                name="area"
                defaultValue={
                  jobType === "Quick" || jobType === "Issues"
                    ? JSON.stringify(filtersMetadata, null, "\t")
                    : "Filter data for configurations coming soon"
                }
                isReadOnly
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              appearance="subtle"
              onClick={() => setShowFilterModal(false)}
              size="small"
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};

export default FiltersModal;
